var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v(_vm._s(_setup.name))]
          ),
          _vm._v(" "),
          !_setup.isDeleted
            ? _c(
                "a",
                {
                  staticClass: "btn btn-link btn-sm",
                  attrs: { role: "button" },
                  on: { click: _setup.handleDeleteConnectorCommandV1 },
                },
                [
                  _c("i", { staticClass: "fa-regular fa-trash-can" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Delete")]),
                ]
              )
            : _c(
                "a",
                {
                  staticClass: "btn btn-link btn-sm",
                  attrs: { role: "button" },
                  on: { click: _setup.handlePermanentDeleteConnectorCommandV1 },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-remove",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Permanently delete")]),
                ]
              ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "a",
        {
          attrs: {
            href: `/#/admin/integrations/connectors/configure/${_setup.id}`,
          },
        },
        [_vm._v("Configure connector")]
      ),
      _vm._v(" "),
      _c("span", [_vm._v("(" + _vm._s(_setup.name) + ")")]),
      _c("br"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }